import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getPrivileges } from './thunks'

const initialState: PrivilegesState = {
  privileges: [],
  status: 'idle',
  error: null,
}

const slice = createSlice({
  name: 'privileges',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPrivileges.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getPrivileges.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getPrivileges.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.privileges = action.payload
      })
  },
})

export const selectPrivileges = (state: RootState): PrivilegesState => state.privileges

export default slice.reducer
